import PackageRepository from "../domain/data/PackageRepository";
import Package from "../domain/entities/Package";
import User from "../domain/entities/User";
import { packages } from "./InitData";
import { v4 as uuidv4 } from "uuid";

export default class MockPackageRepository implements PackageRepository {
  private static packages: Package[] = packages;

  async getPackages(user: User): Promise<Package[]> {
    return MockPackageRepository.packages;
  }

  async savePackage(user: User, objPackage: Package): Promise<Package> {
    if (!objPackage.id) {
      objPackage.id = uuidv4();
      objPackage.organization = MockPackageRepository.packages[0].organization;
      MockPackageRepository.packages.push(objPackage);
      return objPackage;
    } else {
      const record = MockPackageRepository.packages.find(
        (record) => record.id === objPackage.id
      );
      if (record) {
        record.name = objPackage.name;
        record.description = objPackage.description;
        record.documentTemplates = objPackage.documentTemplates;
        record.shared = objPackage.shared;
        //record.organization = userObject.organization;
      }
      return record as Package;
    }
  }

  async deletePackage(user: User, objPackage: Package): Promise<Boolean> {
    const record = MockPackageRepository.packages.find(
      (record) => record.id === objPackage.id
    );
    if (record) {
      MockPackageRepository.packages = MockPackageRepository.packages.filter(
        (record) => record.id !== objPackage.id
      );
      return true;
    }
    return false;
  }
}
